/* ==========================================================================
   Husanara — theme.js
   1. Gemstone strand renderer (placeholder art until photography lands)
   2. Header: drawer, mega menu, search
   3. Disclosures, tabs, quantity, wishlist
   4. Product gallery + variant picker
   5. Cart: quick add, count badge
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };

  /* ------------------------------------------------------------------
     1. Gemstone strand
     Any element with data-stone="#hex" gets one. Once real photography is
     uploaded Shopify renders an <img> instead and this never runs.
     ------------------------------------------------------------------ */
  var uid = 0;

  function mix(hex, target, p) {
    var n = parseInt(hex.replace('#', ''), 16);
    var c = [n >> 16, (n >> 8) & 255, n & 255];
    return 'rgb(' + c.map(function (v) {
      return Math.round(v * (1 - p) + target * p);
    }).join(',') + ')';
  }

  // Point on the necklace curve at t (cubic bezier, matches the design board)
  function curve(t) {
    var p = [[28.8, 0], [43.2, 142.5], [196.8, 142.5], [211.2, 0]];
    var u = 1 - t;
    var x = u * u * u * p[0][0] + 3 * u * u * t * p[1][0] + 3 * u * t * t * p[2][0] + t * t * t * p[3][0];
    var y = u * u * u * p[0][1] + 3 * u * u * t * p[1][1] + 3 * u * t * t * p[2][1] + t * t * t * p[3][1];
    return [x, y];
  }

  function strand(hex, beads, pendant) {
    var id = 'gs' + (++uid);
    var hi = mix(hex, 255, 0.55);
    var lo = mix(hex, 0, 0.6);
    var svg = '<svg viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<defs><radialGradient id="' + id + '" cx="35%" cy="30%" r="75%">' +
      '<stop offset="0%" stop-color="' + hi + '"/>' +
      '<stop offset="45%" stop-color="' + hex + '"/>' +
      '<stop offset="100%" stop-color="' + lo + '"/>' +
      '</radialGradient></defs>' +
      '<path d="M28.8 0 C 43.2 142.5, 196.8 142.5, 211.2 0" fill="none" stroke="#B08D4E" stroke-width="0.9"/>';

    var base = 6.4 + 34 / beads;
    for (var i = 0; i < beads; i++) {
      var t = beads === 1 ? 0.5 : i / (beads - 1);
      var pt = curve(t);
      var r = base * (0.82 + 0.18 * Math.sin(Math.PI * t));
      svg += '<circle cx="' + pt[0].toFixed(1) + '" cy="' + pt[1].toFixed(1) +
             '" r="' + r.toFixed(1) + '" fill="url(#' + id + ')"/>';
    }

    if (pendant) {
      var mid = curve(0.5);
      var drop = mid[1] + base + 4;
      svg += '<path d="M120 ' + (mid[1] + base).toFixed(1) + ' L120 ' + drop.toFixed(1) +
             '" stroke="#B08D4E" stroke-width="1"/>' +
             '<ellipse cx="120" cy="' + (drop + base * 1.3).toFixed(1) +
             '" rx="' + (base * 1.1).toFixed(1) + '" ry="' + (base * 1.45).toFixed(1) +
             '" fill="url(#' + id + ')" stroke="#B08D4E" stroke-width="0.8"/>';
    }

    return svg + '</svg>';
  }

  function hydrateStones(root) {
    (root || document).querySelectorAll('[data-stone]').forEach(function (el) {
      if (el.dataset.stoneDone) return;
      var hex = (el.dataset.stone || '').trim();
      if (!/^#[0-9a-f]{6}$/i.test(hex)) return;
      var beads = parseInt(el.dataset.beads || '15', 10);
      el.insertAdjacentHTML('afterbegin', strand(hex, beads, el.dataset.pendant !== 'false'));
      el.dataset.stoneDone = '1';
    });
  }

  /* ------------------------------------------------------------------
     2. Header
     ------------------------------------------------------------------ */
  function setOpen(el, open) {
    if (el) el.dataset.open = open ? 'true' : 'false';
  }

  function initHeader(scope) {
    var root = scope || document;
    var drawer = document.querySelector('[data-drawer]');
    var scrim = document.querySelector('[data-scrim]');
    var search = document.querySelector('[data-search-panel]');
    var megas = Array.prototype.slice.call(document.querySelectorAll('[data-mega]'));

    function closeAll() {
      setOpen(drawer, false);
      setOpen(scrim, false);
      setOpen(search, false);
      megas.forEach(function (m) { setOpen(m, false); });
      document.querySelectorAll('[data-mega-trigger]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(drawer, true);
        setOpen(scrim, true);
        document.body.style.overflow = 'hidden';
        var first = drawer && drawer.querySelector('button, a');
        if (first) first.focus();
      });
    });

    root.querySelectorAll('[data-close]').forEach(function (btn) {
      btn.addEventListener('click', closeAll);
    });
    if (scrim && !scrim.dataset.bound) {
      scrim.dataset.bound = '1';
      scrim.addEventListener('click', closeAll);
    }

    root.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(search, true);
        var input = search && search.querySelector('input');
        if (input) input.focus();
      });
    });

    root.querySelectorAll('[data-mega-trigger]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      function open() {
        megas.forEach(function (m) { if (m !== panel) setOpen(m, false); });
        document.querySelectorAll('[data-mega-trigger]').forEach(function (b) {
          if (b !== btn) b.setAttribute('aria-expanded', 'false');
        });
        setOpen(panel, true);
        btn.setAttribute('aria-expanded', 'true');
      }
      function close() {
        setOpen(panel, false);
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function () {
        btn.getAttribute('aria-expanded') === 'true' ? close() : open();
      });
      btn.addEventListener('mouseenter', open);
      btn.addEventListener('focus', open);
      panel.addEventListener('mouseleave', close);
      btn.parentElement.addEventListener('mouseleave', function (e) {
        if (!panel.contains(e.relatedTarget)) close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ------------------------------------------------------------------
     3. Disclosures, tabs, quantity, wishlist
     ------------------------------------------------------------------ */
  function initDisclosures(root) {
    (root || document).querySelectorAll('[data-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = panel.dataset.open === 'true';
        setOpen(panel, !open);
        btn.setAttribute('aria-expanded', String(!open));
        var sign = btn.querySelector('[data-sign]');
        if (sign) sign.textContent = open ? '+' : '–';
      });
    });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-tabs]').forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = '1';
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));

      function select(i) {
        tabs.forEach(function (tab, j) {
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', String(i === j));
          tab.tabIndex = i === j ? 0 : -1;
          if (panel) panel.hidden = i !== j;
        });
        tabs[i].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') select((i + 1) % tabs.length);
          if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length);
        });
      });
    });
  }

  function initQty(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initWishlist(root) {
    (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    });
  }

  /* ------------------------------------------------------------------
     4. Product gallery + variant picker
     ------------------------------------------------------------------ */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;

      var mainImage = main.querySelector('[data-gallery-image]');
      var thumbs = gallery.querySelectorAll('.thumb-btn');

      function select(btn) {
        thumbs.forEach(function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });

        if (mainImage && btn.dataset.src) {
          // single image swapped in place — what the thumbnails imply
          mainImage.src = btn.dataset.src;
          if (btn.dataset.srcset) mainImage.srcset = btn.dataset.srcset;
          if (btn.dataset.alt) mainImage.alt = btn.dataset.alt;
          mainImage.dataset.mediaId = btn.dataset.mediaId || '';
          mainImage.removeAttribute('hidden');
        } else {
          // older markup: every image stacked, all but one hidden
          main.querySelectorAll('[data-media-id]').forEach(function (img) {
            img.hidden = img.dataset.mediaId !== btn.dataset.mediaId;
          });
        }
      }

      thumbs.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          select(btn);
        });
        btn.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var next = event.key === 'ArrowRight' ? index + 1 : index - 1;
          if (next < 0) next = thumbs.length - 1;
          if (next >= thumbs.length) next = 0;
          thumbs[next].focus();
          select(thumbs[next]);
        });
      });
    });
  }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var plain = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, plain)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, plain);
  }

  function initVariants(root) {
    (root || document).querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      var dataEl = document.querySelector('[data-variants]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = document.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-price]');
      var addBtn = document.querySelector('[data-add-button]');

      function update() {
        var chosen = Array.prototype.map.call(
          picker.querySelectorAll('input[type="radio"]:checked'),
          function (input) { return input.value; }
        );

        var match = variants.filter(function (v) {
          return chosen.every(function (value, i) { return v.options[i] === value; });
        })[0];

        if (!match) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = theme.strings.sold_out || 'Sold out';
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available
            ? (theme.strings.added ? 'Add to bag' : 'Add to bag')
            : (theme.strings.sold_out || 'Sold out');
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
    });
  }

  /* ------------------------------------------------------------------
     5. Cart
     ------------------------------------------------------------------ */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function initQuickAdd(root) {
    (root || document).querySelectorAll('.quick-add[data-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var original = btn.textContent;
        btn.disabled = true;

        fetch(theme.routes.cart_add || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.add), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            setCartCount(cart.item_count);
            btn.textContent = '✓';
          })
          .catch(function () {
            window.location.href = theme.routes.cart || '/cart';
          })
          .then(function () {
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1400);
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     Boot — re-runs on theme editor section loads
     ------------------------------------------------------------------ */
  function boot(scope) {
    hydrateStones(scope);
    initHeader(scope);
    initDisclosures(scope);
    initTabs(scope);
    initQty(scope);
    initWishlist(scope);
    initGallery(scope);
    initVariants(scope);
    initQuickAdd(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('[data-mega]');
    if (panel) setOpen(panel, true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var panel = e.target.closest('[data-mega]');
    if (panel) setOpen(panel, false);
  });
})();
